<script>
    import {
        debounce,
        QTable,
        QTr,
        QTd,
        QSpinner
    } from 'quasar-framework'
    import fixedTable from '../helpers/fixedTable'

    // Create a mixins that uses the same props from QTable, so we can pass it on
    var mixins = [fixedTable, {
        props: QTable.props
    }]

    // Add the props from QTables mixins, so we can also wait for then.
    QTable.mixins.forEach(m => {
        mixins.push({
            props: m.props
        })
    })

    export default {
        name: 'TableExtended',

        mixins,

        props: {
            infiniteScroll: Boolean,
            height: {
                type: Number,
                default: 330
            },
            distance: {
                type: Number,
                default: 1000
            },
        },
        components: {QTable},
        computed: {
            maxPage() {
                if (this.pagination && this.pagination.rowsPerPage)
                    return Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage)
            }
        },
        methods: {
            onRequest(options) {
                this.$emit('request', options)
            },
        },
        render(h) {
            let scopedSlots = this.$scopedSlots
            if (this.infiniteScroll) {
                if (!scopedSlots['bottom-row'])
                    scopedSlots['bottom-row'] = () => {
                        if (this.infiniteScroll && this.data.length && this.pagination.page < this.maxPage) {
                            return h(QTr, {
                                staticClass: 'ignore-infinite'
                            }, [
                                h(QTd, {
                                    colspan: '100%',
                                    staticClass: 'block text-center ignore-infinite'
                                }, [
                                    h(QSpinner, {
                                        attrs: {color: 'highlight'}
                                    }),
                                    ' ' + this.$T(this.$refs.QTable.loading ? 'loading' : 'pull to load more')
                                ])
                            ])
                        }
                    }
                if (!scopedSlots['pagination'])
                    scopedSlots['pagination'] = () => h('div', {
                        attrs: {style: 'font-size: small'}
                    }, ['teste'])
            }
            let props = deepCopy(this.$props)
            props.data = this.visibleData
            return h(QTable, {
                ref: 'QTable',
                props,
                attrs: this.$attrs,
                on: {
                    request: this.onRequest
                },
                slots: {
                    ...this.$slots
                },
                scopedSlots
            })
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TableExtended.vue